import { render } from "./RechargeRecords.vue?vue&type=template&id=5e987691&scoped=true"
import script from "./RechargeRecords.vue?vue&type=script&lang=js"
export * from "./RechargeRecords.vue?vue&type=script&lang=js"

import "./RechargeRecords.vue?vue&type=style&index=0&id=5e987691&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e987691"]])

export default __exports__